import type { ActionConfig } from './types';

export const requestActions: ActionConfig[] = [
  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'req-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'requests',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 1,
    config: {},
  },
  {
    id: 'req-add',
    name: 'Add',
    icon: 'plus',
    table: 'requests',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 2,
    config: {},
  },

  // =============================================================================
  // SET COLUMN VALUE ACTIONS
  // =============================================================================
  {
    id: 'req-mark-complete',
    name: 'Mark Complete',
    icon: 'check-square',
    table: 'requests',
    type: 'SET_COLUMN_VALUE',
    prominence: 'prominent',
    order: 10,
    condition: (row) => row.status !== 'Complete',
    config: {
      column: 'status',
      value: 'Complete',
    },
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'req-view-client',
    name: 'View Client',
    icon: 'chevron-circle-right',
    table: 'requests',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 20,
    config: {
      route: '/clients/:clientId',
      params: { clientId: 'clientId' },
    },
  },
];
